/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignPipelineConfigUpdatePathParams,
	CampaignPipelineConfigUpdateRequest,
	CampaignPipelineConfigUpdateResponse,
} from '../types/CampaignPipelineConfigUpdate'

/**
 * PUT /campaigns/:campaign/pipeline-config
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::update
 */
export async function campaignPipelineConfigUpdate(
	campaign: CampaignPipelineConfigUpdatePathParams['campaign'],
	data: CampaignPipelineConfigUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignPipelineConfigUpdateResponse>> {
	return axiosInstance.put(`/campaigns/${campaign}/pipeline-config`, data, config)
}
